import BlogLayout from '../../layout/BlogLayout'
import Image1 from '../../assets/blog/article-3/1.webp'
import Image2 from '../../assets/blog/article-3/2.webp'
import Image3 from '../../assets/blog/article-3/3.webp'
import Image4 from '../../assets/blog/article-3/4.webp'

const Article3 = () => {
  return (
    <BlogLayout
      category='Evento'
      title='Renault eligió VIDA para fortalecer su equipo desde el bienestar'
    >
      <p>
        Recibimos en nuestras sedes al equipo de <strong>Calidad de Renault</strong>, que
        eligió VIDA Cowork para realizar una dinámica grupal de integración.
      </p>
      <img src={Image1} alt="Blog" className="img--large" />
      <p>
        El encuentro tuvo como objetivo acompañar el ingreso de nuevos integrantes al equipo,
        conocerse, compartir proyectos, establecer nuevas pautas de trabajo y fortalecer los
        valores que los unen como grupo.
      </p>
      <p>
        Durante la jornada participaron de desafíos dinámicos, diseñados para observar cómo
        se desenvolvían frente a distintas situaciones, identificar fortalezas y construir
        juntos una forma de trabajo más alineada y colaborativa.
      </p>
      <img src={Image2} alt="Blog" className="img--medium" />
      <p>
        Desde el área de <strong>#ComunidadVIDA</strong>, sumamos nuestro toque distintivo
        con una pausa activa que invitó al equipo a reconectar con su cuerpo y su bienestar
        antes de comenzar la jornada.
      </p>
      <p>En VIDA tenemos una fuerte creencia: el trabajo y el bienestar pueden convivir.</p>
      <p>
        Entendemos el bienestar como un equilibrio entre todos los elementos que nos conforman
        como personas, y el trabajo como una parte fundamental de esa ecuación.
      </p>
      <img src={Image3} alt="Blog" className="img--medium" />
      <p>
        Buscamos crear espacios donde ambos conceptos, trabajo y bienestar, se encuentren de
        manera armoniosa.
        Por eso, al planificar este segmento junto a <strong>Geraldine</strong>, <strong>People Care de Renault</strong>,
        pensamos que lo mejor sería ofrecerle al equipo una pista de aterrizaje para la experiencia
        que iban a vivir durante todo el día.
      </p>
      <img src={Image4} alt="Blog" className="img--large" />
      <p>
        La pausa activa fue una invitación a frenar, respirar y calibrar el cuerpo, entendiendo
        que, al igual que una máquina, también necesitamos detenernos por momentos para volver
        a funcionar en nuestro máximo potencial.
        Un breve ejercicio de respiración ayudó a generar ese pequeño “espacio en blanco” que
        permite resetear y encarar el resto de la jornada con energía y presencia. 🌿
      </p>
      <p>
        Nos encanta recibir empresas de esta envergadura y ser parte de experiencias que promueven
        la conexión, el trabajo en equipo y el bienestar.
        💚 Gracias, Renault, por elegirnos y permitirnos dejar nuestra esencia VIDA en cada encuentro.
      </p>
    </BlogLayout>
  )
}

export default Article3